import { render, staticRenderFns } from "../../../pages/corporation/custom/custom.html?vue&type=template&id=480c6a41&scoped=true&"
import script from "../../../pages/corporation/custom/custom.js?vue&type=script&lang=js&"
export * from "../../../pages/corporation/custom/custom.js?vue&type=script&lang=js&"
import style0 from "../../../pages/corporation/custom/custom.css?vue&type=style&index=0&id=480c6a41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480c6a41",
  null
  
)

export default component.exports